// @flow
import React from 'react';

import Link from '@waglabs/link';

type Props = {
  href: string,
};

export const ExternalLink = (props: Props) => (
  <Link
    display="inline-block"
    color="white"
    bg="wagGreen"
    p="8px 0px"
    m="0 auto"
    textAlign="center"
    borderRadius="8px"
    fontWeight="bold"
    width={[260, 212, 260]}
    boxSizing="border-box"
    {...props}
  />
);
